module.exports = __webpack_public_path__ + "img/Uniteller_Visa_MasterCard_MIR.3319c30d.png";